import '@zyno-io/vue-foundation/dist/vue-foundation.css';
import './shared/styles/tailwind.css';

import * as Sentry from '@sentry/vue';
import { uxrr } from '@zyno-io/uxrr-client';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

import App from './app.vue';
import { setupVf } from './vf.setup';

// lazy
import('@fortawesome/fontawesome-pro/css/all.css');

// Extract apiUrl from hash (e.g. #apiUrl=http://localhost:3006) — dev only
if (import.meta.env.DEV) {
    const hashParams = new URLSearchParams(location.hash.slice(1));
    const hashApiUrl = hashParams.get('apiUrl');
    if (hashApiUrl) sessionStorage.setItem('c2c:apiUrl', hashApiUrl);
}

import './openapi-client';

if (!import.meta.env.DEV) {
    uxrr.init({
        endpoint: 'https://uxrr.s24.dev',
        appKey: '@c2cfsi/agent-app',
        version: import.meta.env.VITE_APP_VERSION
    });
}

const app = createApp(App);

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/', component: () => import('./components/agent.vue') },
        {
            path: '/manager',
            component: () => import('./components/manager.vue'),
            children: [
                { path: '', redirect: '/manager/agents' },
                {
                    path: 'agents',
                    component: () => import('./components/manager/agents.vue')
                },
                {
                    path: 'calls',
                    component: () => import('./components/manager/calls.vue')
                },
                {
                    path: 'receipts',
                    component: () => import('./components/manager/receipts.vue')
                },
                {
                    path: 'pif-cr',
                    component: () => import('./components/manager/pif-credit-removals.vue')
                },
                {
                    path: 'ph1cc',
                    component: () => import('./components/manager/ph1cc.vue')
                },
                {
                    path: 'files',
                    component: () => import('./components/manager/files.vue')
                },
                {
                    path: 'ml-cohort',
                    component: () => import('./components/manager/ml-cohort.vue')
                }
            ]
        }
    ]
});

if (import.meta.env.VITE_APP_SENTRY_DSN) {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_APP_SENTRY_DSN,
        release: import.meta.env.VITE_APP_VERSION,
        integrations: [Sentry.browserTracingIntegration({ router })],
        tracesSampleRate: 0.2
    });
}

setupVf(app);

const pinia = createPinia();
app.use(pinia);

app.use(router);

app.mount(document.body);
